import React, { Component } from 'react';
import './App.css';
import Amplify, { API, graphqlOperation } from 'aws-amplify';
import * as queries from './graphql/queries';
import * as mutations from './graphql/mutations';
import awsmobile from './aws-exports';
import { withAuthenticator } from 'aws-amplify-react';
import MaterialTable from 'material-table';
import Subtask from './components/subtask'
Amplify.configure(awsmobile);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newItem: '',
      allTasks: [],
      DeleteTask: null,
      CompleteTask: null,
      currentTask: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.createTask = this.createTask.bind(this);
    this.currentTasks = this.currentTasks.bind(this);
  }

  componentDidMount = async() => {
    await this.refreshAllTasks()
  }

  componentDidUpdate = async() => {
    if (this.state.DeleteTask != null) {
      const deleteTaskId = this.state.DeleteTask.id
      const child_tasks = await API.graphql(graphqlOperation(queries.listTasks, {filter: {parentTaskId: {eq: deleteTaskId}}, limit: 999999999}));
      console.log("child_tasks:" + JSON.stringify(child_tasks))
      await child_tasks.data.listTasks.items.map(task => {
        return this.subTaskDelete(task)
      })
      const deleteTask = await API.graphql(graphqlOperation(mutations.deleteTask, {input: {id: deleteTaskId }}));
      console.log(deleteTask);
      this.setState({DeleteTask: null})
    }

    if (this.state.CompleteTask != null) {
      var updatedTask =  this.state.CompleteTask;
      updatedTask.state = 'completed'
      let {tableData, ...graphqlUpdatedTask} = updatedTask;
      const completeTask = await API.graphql(graphqlOperation(mutations.updateTask, {input: graphqlUpdatedTask}));
      console.log(completeTask);
      this.setState({CompleteTask: null})
    }
  }

  subTaskDelete = async(task) => {
    var currentDeleteTask;
    const child_tasks = await API.graphql(graphqlOperation(queries.listTasks, {filter: {parentTaskId: {eq: task.id}}, limit: 999999999}));
    await Promise.all(child_tasks.data.listTasks.items.map(subtask => {
      return this.subTaskDelete(subtask)
    }))
    currentDeleteTask = await API.graphql(graphqlOperation(mutations.deleteTask, {input: {id: task.id }}));
    await this.refreshAllTasks()
    return console.log(currentDeleteTask);
  }

  handleChange(event) {
    this.setState({newItem: event.target.value});
  }

  changePomodoro = (tempCurrentTask, completed, total) => {
    tempCurrentTask.pomodoros = (parseInt(tempCurrentTask.pomodoros) + completed).toString();
    tempCurrentTask.estimatedPomodoro = (parseInt(tempCurrentTask.estimatedPomodoro) + total).toString();

    this.setState({currentTask: tempCurrentTask});
  }


  addPomodoro = (tempCurrentTask) => {
    tempCurrentTask.pomodoros = (parseInt(tempCurrentTask.pomodoros) + 1).toString();
    this.setState({pomodoros: tempCurrentTask.pomodoros});
  }

  subtractPomodoro = (tempCurrentTask) => {
    tempCurrentTask.pomodoros = (parseInt(tempCurrentTask.pomodoros) - 1).toString();
    this.setState({pomodoros: tempCurrentTask.pomodoros});
  }

  addPomodoroEstimate = (tempCurrentTask) => {
    tempCurrentTask.estimatedPomodoro = (parseInt(tempCurrentTask.estimatedPomodoro) + 1).toString();
    this.setState({estimatedPomodoro: tempCurrentTask.estimatedPomodoro });
  }

  subtractPomodoroEstimate = (tempCurrentTask) => {
    tempCurrentTask.estimatedPomodoro = (parseInt(tempCurrentTask.estimatedPomodoro) - 1).toString();
    this.setState({estimatedPomodoro: tempCurrentTask.estimatedPomodoro });
  }



  isLargeNumber = (element, element2) => {
    return element === 13;
  }

  createTask = async () => {
    var randomColor = require('randomcolor')
    var color = randomColor();
    console.log('A name was submitted: ' + this.state.newItem);
    const todoDetails = {
      name: this.state.newItem,
      description: 'Learn AWS AppSync',
      color: color,
      pomodoros: 0,
      estimatedPomodoro: 1,
      state: 'new',
      deadline: 'none',
      parentTaskId: 'none'
    };

    const newTask = await API.graphql(graphqlOperation(mutations.createTask, {input: todoDetails}));
    console.log(newTask);
    await this.refreshAllTasks()
  }

  refreshAllTasks = async () => {
    const allTasks = await API.graphql(graphqlOperation(queries.listTasks, {filter: {parentTaskId: {eq: "none"}}, limit: 999999999}));
    console.log(allTasks);
    this.setState({allTasks: allTasks})
  }

  currentTasks = () => {
    const taskArrayData = this.state.allTasks.data;
    const appThis = this;
    if (taskArrayData === undefined) {
      return (<div/>)
    } else {
      return (
        <div style={{ maxWidth: '100%' }}>
         <MaterialTable
           columns={[
            { title: 'Task', field: 'name', render: rowData => {
              return (<div>{rowData.name}</div>);
            }},
            { title: 'Time Spent', field: 'pomodoros', render: rowData => {
              const pomodoroRatio = rowData.pomodoros + "/" + rowData.estimatedPomodoro;
              return (<div>{pomodoroRatio}</div>);
            }},
            { title: 'Deadline', field: 'deadline' },
            {
              title: 'Progress',
              field: 'successScore',
              render: rowData => {
                const numScore =  (100 * rowData.pomodoros / rowData.estimatedPomodoro).toPrecision(3);
                const score = numScore + '%'
                var width = '100%';
                if (numScore < 100) {
                  width = score;
                }
                var color = numScore > 70 ? '#4CAF50' : '#f44336'
                if (numScore > 100) color = '#800080';
                if (rowData.state === 'completed') color = '#1E90FF';
                return (
                  <div style={{ width: '100%', backgroundColor: '#ddd', height: 20 }}>
                    <div
                      style={{
                        textAlign: 'left',
                        padding: 1,
                        color: 'white',
                        width: width,
                        backgroundColor: color,
                        height: 20,
                      }}
                    >
                      {score}
                    </div>
                  </div>
                )
              },
            },
           ]}
           data={ this.state.allTasks.data.listTasks.items }
           title="Tasks to Do"
           options={{
             toolbar: false,
             paging: false
           }}
           actions={[
             {
               icon: 'done',
               tooltip: 'Mark Done',
               onClick: (event, rows) => {
                 appThis.setState({CompleteTask: rows})
               },
             },
             {
               icon: 'delete',
               tooltip: 'Delete',
               onClick: (event, rows) => {
                 appThis.setState({DeleteTask: rows})
               },
             },
           ]}
           detailPanel={rowData => {
             return (
               <Subtask
                 data={rowData}
                 addPomodoro={() => this.addPomodoro(rowData)}
                 subtractPomodoro={() => this.subtractPomodoro(rowData)}
                 addPomodoroEstimate={() => this.addPomodoroEstimate(rowData)}
                 subtractPomodoroEstimate={() => this.subtractPomodoroEstimate(rowData)}>
               </Subtask>
             )
           }}
         />
       </div>
      )
    }
  }

  render() {
    return (
      <div>
        <div className="App" style={{ maxWidth: '100%' }}>
        <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
          { this.currentTasks() }
          <input type="text" value={this.state.newItem} name="title" placeholder={'New Task Description'} onChange={this.handleChange} />
          <button onClick={this.createTask}>Add item</button>
        </div>
      </div>
    );
  }
}

export default withAuthenticator(App, true);
